import { css, keyframes } from '@emotion/css';

// useCompleteAnimation에서 classList로 추가/제거하는 상태 클래스 (emotion 클래스는 셀렉터에 중첩할 수 없어 일반 문자열 사용)
export const none = 'none';
export const hide = 'hide';
export const animate = 'animate';

const animationStart = 'transform: rotate(-30deg) scale(1.3) translateX(100px);';

const complete = keyframes`
    0% {
        ${animationStart}
    }
    50% {
        transform: scale(1.4);
    }
    100% {
        transform: none;
    }
`;

export const container = css`
    background-color: var(--color-gray2);
    height: 100%;
    left: 0;
    padding-top: 66px;
    position: absolute;
    top: 0;
    transition: 350ms ease-in-out;
    width: 100%;
    z-index: 4;

    &.${none} {
        display: none;
    }

    &.${hide} {
        opacity: 0;
        transform: translateY(100vh);
    }
`;

export const card = css`
    ${animationStart}
    filter: drop-shadow(0 2.94px 23.522px rgba(0, 0, 0, 0.14));
    height: auto;
    transition: 300ms;
    width: 100%;
    aspect-ratio: 1.5;
    object-fit: cover;
    border-radius: 8px;

    &.${animate} {
        animation: 1200ms ${complete} ease-in-out forwards;
    }
`;
